/**
 * @description These variables will be used when environment is set to test
 * @exports environment
*/
export const environment = {
  production: false,
  enableLogging:true,
  backendUrl: 'https://optimus-tst.musea2.azure.ext.gm.com/kpiserver/api/kpid-server',
  // backendUrl: 'http://localhost:5000/api/kpid-server',
  vcmuUrl: '',
    auth: {
      authority: 'https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d/v2.0',
      redirect_uri: window.location.origin + '/kpidashboard/app-auth-callback',
      post_logout_redirect_uri: window.location.origin + '/kpidashboard',
      end_session_endpoint: '',
      client_id: '4a259879-7922-4525-a699-e0835705742c',
      scopes: 'https://optimus-tst.musea2.azure.ext.gm.com/kpidashboard/.default',
      issuer: 'https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d/v2.0',
  }
};
